const E404 = () => (
  <div className="error-container error-404">
    <h1>404</h1>
    <p className="title">Page Not Found</p>
    <p>Sorry, the page you're looking for doesn't exist.</p>
  </div>
);

export default E404;